import * as React from "react";
const SvgInfo = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 4a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4m0 1.8A10.2 10.2 0 1 1 5.8 16 10.186 10.186 0 0 1 16 5.8m0 4.2a1.2 1.2 0 1 0 1.2 1.2A1.2 1.2 0 0 0 16 10m-.014 4.187a.9.9 0 0 0-.886.913v6.6a.9.9 0 1 0 1.8 0v-6.6a.9.9 0 0 0-.914-.913", "data-name": "Group 357913" }));
export default SvgInfo;
